import { render, staticRenderFns } from "./TruckMiniIcon.vue?vue&type=template&id=9b4a28e8"
import script from "./TruckMiniIcon.vue?vue&type=script&lang=js"
export * from "./TruckMiniIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports